import {
  useExperimentRepo,
  useVariationRepo,
  usePageRepo,
  useUrlRuleRepo,
} from '@/shared/store/models';

export function clearAllExperiments() {
  const experimentRepo = useExperimentRepo();
  const variationRepo = useVariationRepo();
  const pageRepo = usePageRepo();
  const urlRuleRepo = useUrlRuleRepo();

  // Get all experiments
  const experiments = experimentRepo.all();

  // Delete all related data for each experiment
  experiments.forEach((experiment) => {
    if (experiment.id) {
      // Delete all variations for this experiment
      const variations = variationRepo.where('experimentId', experiment.id).get();
      variations.forEach((variation) => {
        if (variation.id) {
          variationRepo.destroy(variation.id);
        }
      });

      // Delete all pages and their URL rules for this experiment
      const pages = pageRepo.where('experimentId', experiment.id).get();
      pages.forEach((page) => {
        if (page.id) {
          // Delete URL rules for this page
          const urlRules = urlRuleRepo.where('pageId', page.id).get();
          urlRules.forEach((rule) => {
            if (rule.id) {
              urlRuleRepo.destroy(rule.id);
            }
          });
          // Delete the page
          pageRepo.destroy(page.id);
        }
      });

      // Finally, delete the experiment
      experimentRepo.destroy(experiment.id);
    }
  });

  console.log('All experiments and related data have been deleted.');
}

// Make it available globally for console use
if (typeof window !== 'undefined') {
  (window as any).clearAllExperiments = clearAllExperiments;
}
